export default __webpack_public_path__ + "static/media/transa.7884efb5.svg";